<template>
  <div>
    <component :is="template" />

    <div class="clearfix"></div>
  </div>
</template>

<script>
import { EventBus } from '@/main';
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'HeaderRight',
  data () {
    return {
      template: 'Private',
      showSearch: true,
      searchDenyRoutes: [
        'Login',
        'Signup',
        'Profile',
        'PrivacyPolicy',
        // 'About',
        // 'Help',
        'TermsOfUse',
        'ContactSupport'
      ]
    }
  },
  computed: {
    ...mapGetters([
      'subscriberid',
      'AppUser'
    ])
  },
  components: {
    Private : () => import("@/components/Header/Right/Private.vue")
  },
  created () {
    EventBus.$on('AppUserChangeEvent', this.AppUserChangeCB);
  },
  methods: {
    ...mapMutations([
      'CommitConfigStore',
      'CommitUserStore'
    ]),
    getRightTemplate () {
      // Defined in User Store
      this.CommitConfigStore();
    },
    AppUserChangeCB (state) {
      if (!state) return;
      // Get the template component
      this.getRightTemplate();
    }
  }
}
</script>

<style lang="scss">
@import '~sass/modules/components';
.vlt-header-r-sec {
  float: left;
}
.vlt-header-notif, .vlt-header-prof {
  float: left;
  margin-left: 25px;
}
.vlt-header-notif {
  button {
    position: relative;
    z-index: 91;
    img {
      width: 20px;
    }
  }
}
.vlt-btn-ico {
  padding: 12px 0;
  &.visible {
    position: relative;
    &::before {
      position: absolute;
      content: '';
      border-left: 7px solid transparent;
      border-right: 7px solid transparent;
      border-bottom: 7px solid $clr-dark-grad-2;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
.vlt-header-prof {
  position: relative;
  .profile-menu {
    position: absolute;
    top: 40px;
    right: 0;
  }
}
.vlt-hprof {
  padding: 8px 0;
  img {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    vertical-align: middle;
  }
}
.vlt-header-anony {
  float: left;
}
.vlt-header-login {
  margin-left: 15px;
  margin-top: 10px;
}

</style>



// WEBPACK FOOTER //
// src/components/Header/Right/HeaderRight.vue